import React from 'react';
import { RouteObject } from 'react-router-dom';

const TogReportsIndex    = React.lazy(() => import('./pages/TogReportsIndex'));
const TogSentReport      = React.lazy(() => import('./pages/TogSentReport'));
const TogReceivedReport  = React.lazy(() => import('./pages/TogReceivedReport'));
const StaffSummaryReport = React.lazy(() => import('./pages/StaffSummaryReport'));
const StaffDetailReport  = React.lazy(() => import('./pages/StaffDetailReport'));

const togReportRoutes: RouteObject[] = [
    {
        index: true,
        element: <TogReportsIndex />,
    },
    {
        path: 'sent',
        element: <TogReportsIndex />,
    },
    {
        path: 'received',
        element: <TogReportsIndex />,
    },
    {
        path: 'staff-summary',
        element: <TogReportsIndex />,
    },
    {
        path: 'staff-summary/:userId',
        element: <StaffDetailReport />,
    },
];

export default togReportRoutes;
